import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.page)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.pageHeader)
    }, " История обновлений ", 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.items)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(_ctx.$style.item)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.itemHeader)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.itemHeaderTitle)
            }, _toDisplayString(item.title) + " " + _toDisplayString(item.version_backend), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.itemHeaderMeta)
            }, " (" + _toDisplayString(_ctx.formatDate(new Date(item.published_at), 'ru')) + ") ", 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.itemBody)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.itemBodyText),
              innerHTML: item.text_backend
            }, null, 10, _hoisted_1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.itemBodyText),
              innerHTML: item.text_frontend
            }, null, 10, _hoisted_2)
          ], 2)
        ], 2))
      }), 128))
    ], 2)
  ], 2))
}